module.exports = __webpack_public_path__ + "static/livestreaming-3-fd8158661b9f87aff2570ae3167d6a80.jpg";